import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import values from 'lodash.values';
import classNames from 'classnames';
import {categoryHref} from 'lib/categories';
import Button from '../Button';
import Logo from '../Logo';
import ContactLink from './ContactLink';
import styles from './nav.module.scss';

class Nav extends Component {
  state = {
    isActive: false,
  };

  componentDidMount = () => {
    window.addEventListener('scroll', this.dismiss);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.dismiss);
  };

  dismiss = () => {
    const {isActive} = this.state;
    if (isActive) {
      this.setState({isActive: false});
    }
  };

  toggleActive = () => {
    const {isActive} = this.state;
    this.setState({isActive: !isActive});
  };

  render() {
    const {articleTree} = this.props;
    const {isActive} = this.state;

    return (
      <nav
        aria-label="main navigation"
        className={classNames('navbar', styles.Nav)}
        role="navigation"
      >
        <div className="navbar-brand">
          <Link className={styles.Nav__brand} to="/">
            <Logo className={styles.Nav__logo} />
            <span className={styles.Nav__product}>Support</span>
          </Link>
          <a
            aria-expanded={isActive}
            aria-label="menu"
            className={classNames('navbar-burger', styles.Nav__burger, {
              'is-active': isActive,
            })}
            onClick={this.toggleActive}
            role="button"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          className={classNames('navbar-menu', styles.Nav__menu, {
            'is-active': isActive,
          })}
        >
          <div className="navbar-start">
            <div className="navbar-item has-dropdown is-hoverable">
              <Link
                className={classNames('navbar-link', styles.Nav__link)}
                to="/article/77-welcome-to-teamgantt"
              >
                Help docs
              </Link>
              <div
                className={classNames('navbar-dropdown', styles.Nav__dropdown)}
              >
                {values(articleTree).map(category => (
                  <Link
                    className={classNames(
                      'navbar-item',
                      styles.Nav__dropdownItem
                    )}
                    key={category.id}
                    to={categoryHref(category)}
                  >
                    {category.name}
                  </Link>
                ))}
              </div>
            </div>
            <a
              className={classNames('navbar-item', styles.Nav__link)}
              href="https://www.teamgantt.com/"
            >
              TeamGantt.com
            </a>
          </div>
          <div className={classNames('navbar-end', styles.Nav__actions)}>
            <Button
              href="https://app.teamgantt.com/login"
              size="small"
              variant="secondary"
            >
              Log in
            </Button>
            <ContactLink />
          </div>
        </div>
      </nav>
    );
  }
}

Nav.propTypes = {
  articleTree: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/header/Nav.js